import { useAtomValue, useSetAtom } from "jotai";
import { TextBulletedIcon } from "@/icons/widget-menu/index";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";
import styles from "../../WidgetMenu.module.css";
import { applyValue } from "../applyValue";
import { setNewOptions } from "../setNewOptions";

interface UseTextBulletedButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function useTextBulletedButton({
    setActiveSubMenu,
}: UseTextBulletedButtonProps): MenuOptionResult {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("textBulleted"));
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const uniqueValues = [...new Set(options.map((option) => option.value))];
    const isBulleted = uniqueValues.length === 1 && (uniqueValues[0] as boolean);

    const handleClick = () => {
        setActiveSubMenu(null);

        const setTextBulletedOptions = setNewOptions({
            name: "textBulleted",
            setWidgetMenuOptions,
        });

        applyValue({ options, value: !isBulleted, setNewOptions: setTextBulletedOptions });
    };

    const content = <TextBulletedIcon className={isBulleted ? styles.svgFillActive : ""} />;

    return {
        content,
        handleClick,
        isActive: isBulleted,
    };
}
